// extracted by mini-css-extract-plugin
export var actions = "_78-8";
export var arrow = "_78-5";
export var card = "_78-0";
export var cardWrapper = "_78-9";
export var fieldName = "_78-3";
export var newValue = "_78-6";
export var oldValue = "_78-4";
export var orangeGlowFade = "_78-c";
export var productSection = "_78-1";
export var scrollToBottom = "_78-b";
export var scrollToBottomAnchor = "_78-a";
export var scrollToBottomIcon = "_78-d";
export var showAllButton = "_78-7";
export var table = "_78-2";